import { supabase, isSupabaseConfigured } from "../lib/supabaseClient";
import { portfolioPackages as staticPortfolioPackages } from "../content/portfolioPackages";

const TABLE_NAME = "portfolio_packages";

const mapRecord = (record) => ({
    id: record.id,
    slug: record.slug,
    cardTitle: record.card_title ?? record.cardTitle ?? record.title,
    cardSummary: record.card_summary ?? record.cardSummary ?? "",
    title: record.title,
    meta: record.meta ?? [],
    body: record.body ?? [],
    ctaLabel: record.cta_label ?? record.ctaLabel ?? "Brief iste",
    ctaUrl: record.cta_url ?? record.ctaUrl ?? "mailto:studio@modelerman.com",
    orderIndex: record.order_index ?? record.orderIndex ?? 0,
    published: record.published ?? true,
});

const toSupabaseRecord = (record, index = 0) => ({
    id: record.id,
    slug: record.slug,
    card_title: record.cardTitle ?? record.title,
    card_summary: record.cardSummary ?? "",
    title: record.title,
    meta: record.meta ?? [],
    body: record.body ?? [],
    cta_label: record.ctaLabel ?? "Brief iste",
    cta_url: record.ctaUrl ?? "mailto:studio@modelerman.com",
    order_index: record.orderIndex ?? index,
    published: record.published ?? true,
});

export const fetchPortfolioPackages = async () => {
    if (!isSupabaseConfigured || !supabase) {
        return staticPortfolioPackages.map((item, index) => ({ ...item, orderIndex: index }));
    }

    const { data, error } = await supabase
        .from(TABLE_NAME)
        .select("id, slug, card_title, card_summary, title, meta, body, cta_label, cta_url, order_index, published")
        .order("order_index", { ascending: true });

    if (error) {
        console.error("Supabase fetchPortfolioPackages error", error);
        throw error;
    }

    return (data ?? []).map(mapRecord);
};

export const upsertPortfolioPackage = async (payload) => {
    if (!isSupabaseConfigured || !supabase) {
        throw new Error("Supabase yapılandırılmadan kayıt güncellenemez. Lütfen .env içinde REACT_APP_SUPABASE_URL ve REACT_APP_SUPABASE_ANON_KEY değerlerini tanımlayın.");
    }

    const { data, error } = await supabase
        .from(TABLE_NAME)
        .upsert(toSupabaseRecord(payload, payload.orderIndex))
        .select()
        .single();

    if (error) {
        console.error("Supabase upsertPortfolioPackage error", error);
        throw error;
    }

    return mapRecord(data);
};

export const deletePortfolioPackage = async (id) => {
    if (!isSupabaseConfigured || !supabase) {
        throw new Error("Supabase yapılandırılmadan kayıt silinemez.");
    }

    const { error } = await supabase.from(TABLE_NAME).delete().eq("id", id);

    if (error) {
        console.error("Supabase deletePortfolioPackage error", error);
        throw error;
    }

    return true;
};

export const reorderPortfolioPackages = async (orderedIds) => {
    if (!isSupabaseConfigured || !supabase) {
        throw new Error("Supabase yapılandırılmadan sıralama güncellenemez.");
    }

    const updates = orderedIds.map((id, index) => ({ id, order_index: index }));
    const { error } = await supabase.from(TABLE_NAME).upsert(updates);

    if (error) {
        console.error("Supabase reorderPortfolioPackages error", error);
        throw error;
    }

    return true;
};

export const seedPortfolioPackages = async () => {
    if (!isSupabaseConfigured || !supabase) {
        throw new Error("Supabase yapılandırması yapılmadan veri yüklenemez.");
    }

    const payload = staticPortfolioPackages.map((item, index) => toSupabaseRecord({ ...item, orderIndex: index }, index));

    const { data, error } = await supabase.from(TABLE_NAME).upsert(payload, { onConflict: "id" }).select();

    if (error) {
        console.error("Supabase seedPortfolioPackages error", error);
        throw error;
    }

    return (data ?? payload).map(mapRecord).sort((a, b) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0));
};
